module.exports = __webpack_public_path__ + "img/Weapon_215.73a83a80.png";